import { render, staticRenderFns } from "./CoozzyFormSelect.vue?vue&type=template&id=cd193828&scoped=true"
import script from "./CoozzyFormSelect.vue?vue&type=script&lang=js"
export * from "./CoozzyFormSelect.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFormSelect.vue?vue&type=style&index=0&id=cd193828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd193828",
  null
  
)

export default component.exports